import React from 'react'
import PaymentErr from '../../assests/images/3647986.jpg'
function PaymentFailed() {
    return (
        <>
            <section className="loginSection">
                <div className="container centerDiv">
                    <div className="loginBgImg"></div>
                    <div className="loginBg">
                        <div className="row"></div>
                        <div className="col-md-6 logincredDetail">
                            
                            <div className="loginFormSec login_left_section">
                                <div className="loginLogo">
                                    
                                    {/* <img src={company?.logo} alt="" /> */}
                                </div>


                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="paymentErrorSec">
                                <div className="welcomHeadSec">
                                    <h2 style={{color:'#d02323'}}>Payment Failed</h2>
                                    <p style={{color:"#777272"}}>Your payment couldn't be processed successfully,Please try agian later..</p>
                                </div>
                                <div className="welcomeImg">
                                    <img src={PaymentErr} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default PaymentFailed